'use client'

import SampleRequest from "@/components/contact/sampleRequest/SampleRequest"
import ReCaptchaProvider from "@/components/home/contactForm/ReCaptchaProvider"



export default function TestRequest(){

  return (
    <ReCaptchaProvider>
      <SampleRequest/>
    </ReCaptchaProvider>
  )
}